import { TrendingUp } from "lucide-react";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from "recharts";
import { COLORS } from "../../../lib/constants";
import {
  CHART_HEIGHT, AXIS_TICK, AXIS_STROKE, GRID_STROKE, TOOLTIP_STYLE,
} from "../lib/chartTokens";

export const CrossTabChart = ({ data }) => (
  <div className="bg-card border border-border rounded-xl p-5">
    <h3 className="text-base font-semibold mb-4 flex items-center gap-2">
      <TrendingUp className="w-4 h-4 text-primary" />
      Founder Gender × Value Orientation (Core Hypothesis)
    </h3>
    <div className={CHART_HEIGHT}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" stroke={GRID_STROKE} />
          <XAxis type="number" stroke={AXIS_STROKE} tick={AXIS_TICK} />
          <YAxis dataKey="founder" type="category" stroke={AXIS_STROKE} width={100} tick={AXIS_TICK} />
          <Tooltip {...TOOLTIP_STYLE} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Bar dataKey="care" stackId="a" fill={COLORS.care} name="Care-Centered" />
          <Bar dataKey="utility" stackId="a" fill={COLORS.utility} name="Utility" />
          <Bar dataKey="creative" stackId="a" fill={COLORS.creative} name="Creative" />
          <Bar dataKey="extraction" stackId="a" fill={COLORS.extraction} name="Extraction" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default CrossTabChart;
